// Registro central de partners co-branded de OperaSafe.cl.
//
// Para agregar un partner nuevo, basta con añadir una entrada a este arreglo:
//   - code:       identificador corto en MAYÚSCULAS (se guarda en la BD y va en el asunto del email).
//   - name:       nombre visible de la marca (badge en el CRM, banners, etc.).
//   - path:       segmento de URL y subdominio. Ej: "gremio" => /gremio y gremio.operasafe.cl
//   - logo:       logo del partner para el header (sobre fondo claro).
//   - logoWhite:  logo del partner para el banner del Hero (sobre fondo oscuro).
//   - bannerText: texto del banner de beneficio que se muestra en el Hero.
//   - badgeClass: (opcional) clases Tailwind del badge en el CRM.
//
// Las rutas (/<path> y /<path>/siniestro) se generan automáticamente en App.js,
// y el filtro de "Origen" del panel de Admin se construye solo a partir de esta lista.
export const PARTNERS = [
  {
    code: "OXYGEN",
    name: "Oxygen",
    // Genera /Oxygen y /Oxygen/siniestro (el match de rutas no distingue mayúsculas,
    // así que /oxygen también funciona) y el subdominio oxygen.operasafe.cl.
    path: "Oxygen",
    logo: "/brand/partners/oxygen-ink.png",
    // El wordmark es muy ancho (7.4:1): se controla por ancho, no por alto.
    logoClass: "w-[78px] sm:w-[130px] lg:w-[190px] h-auto",
    logoWhite: "/brand/partners/oxygen-white.png",
    bannerText: "Beneficio exclusivo para clientes y colaboradores de Oxygen",
    badgeClass: "border-brand-ink bg-brand-ink text-white",
  },
];

export const getPartnerByPath = (segment) =>
  PARTNERS.find((p) => p.path.toLowerCase() === (segment || "").toLowerCase()) || null;

export const getPartnerByCode = (code) =>
  PARTNERS.find((p) => p.code.toLowerCase() === (code || "").toLowerCase()) || null;
